// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2nmBu","footer":"ModalUpdate_footer__3l9ss"};